// src/components/RequireAuth.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "../utils/auth";

export default function RequireAuth({ children }) {
  const token = getToken();
  const location = useLocation();

  if (!token) {
    // token yo'q => login sahifasiga yuboramiz
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
